// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3tt2D","notes":"Notes_notes__hDQcH"};